import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=7b1b37dc"
import script from "./origin.vue?vue&type=script&lang=js"
export * from "./origin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports